<template>
  <router-view/>
</template>

<script>
export default {
  name: 'User',
  data: () => ({
  }),
  mounted() {
  },
  methods: {
  },
};
</script>

<style>

</style>
